/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Container, Col, Button, FormGroup, Label, Input, Row, Spinner } from 'reactstrap'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { checkRetroactive } from '../../../store/ducks/humanResources'
import { history } from '../../../store/index'

class RetroactiveExpedient extends Component {
  constructor(props) {
    super(props)
    this.state = {
      retroactiveDate: '',
      retroactiveDateInputError: '',
      retroactiveCheckInTime: '',
      retroactiveCheckInTimeInputError: '',
      retroactiveCheckOutTime: '',
      retroactiveCheckOutTimeInputError: '',
      justificativa: '',
    }
    this.files = React.createRef()
  }

  componentDidUpdate(prevProps) {
    const {
      retroactiveDate, retroactiveCheckInTime, retroactiveCheckOutTime, justificativa,
    } = this.state

    const {
      checkRetroactiveIsLoading, checkRetroactiveError, checkRetroactiveResult,
    } = this.props.humanResources

    const checkPassed = checkRetroactiveResult && checkRetroactiveResult.ok === true

    if (
      !checkRetroactiveIsLoading
      && !checkRetroactiveError
      && checkPassed
      && checkRetroactiveIsLoading !== prevProps.humanResources.checkRetroactiveIsLoading
    ) {
      return history.push({
        pathname: '/recursos-humanos/encerrar-expediente',
        props: {
          Data: moment(retroactiveDate).format('yyyy-MM-DD'),
          DataEntrada: retroactiveCheckInTime,
          DataSaida: retroactiveCheckOutTime,
          retroativo: true,
          fullDate: moment(retroactiveDate).format('dddd, DD [de] MMMM [de] YYYY'),
          exitTime: moment(retroactiveDate),
          justificativa,
        },
      })
    }

    return null
  }

  strToMins = (t) => {
    const s = t.split(':')
    return Number(s[0]) * 60 + Number(s[1])
  }

  minsToStr = (t) => {
    const hours = Math.trunc(t / 60)

    if (hours > 9) {
      return `${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
    }
    return `0${Math.trunc(t / 60)}:${(`00${t % 60}`).slice(-2)}`
  }

  getPreviousWorkday = () => {
    // Based on the current day, handle accordingly
    switch (moment().day()) {
      // If it is Saturday(6), or Sunday (0), Get the previous Friday (5)
      // and ensure we are on the previous week
      case 0:
      case 6:
        return moment().subtract(6, 'days').day(5)
      // If it any other weekend, just return the previous day
      default:
        return moment()
    }
  }

  getSubtractFactor = () => {
    console.tron.log(moment().day())
    switch (moment().day()) {
      case 0:
        return 1
      case 1:
        return 4
      case 2:
        return 4
      case 3:
        return 2
      case 4:
        return 2
      case 5:
        return 2
      case 6:
        return 1
      default:
        return 0
    }
  }

  handleCheckRetroactiveSubmit = () => {
    const {
      retroactiveDate, retroactiveCheckInTime, retroactiveCheckOutTime, justificativa,
    } = this.state
    const { checkRetroactive } = this.props

    if (
      !HOUR_MINUTE_REGEX.test(retroactiveCheckInTime)
      || (
        moment(retroactiveDate).format('L') === moment().format('L')
        && (this.strToMins(retroactiveCheckInTime) > this.strToMins(moment().format('LT')))
      )
    ) {
      this.setState({ retroactiveCheckInTimeInputError: 'Valor inválido.' })
    }
    if (
      !HOUR_MINUTE_REGEX.test(retroactiveCheckOutTime)
      || (this.strToMins(retroactiveCheckOutTime) - this.strToMins(retroactiveCheckInTime) <= 0)
      || (
        moment(retroactiveDate).format('L') === moment().format('L')
        && (this.strToMins(retroactiveCheckOutTime) > this.strToMins(moment().format('LT')))
      )
    ) {
      this.setState({ retroactiveCheckOutTimeInputError: 'Valor inválido.' })
    }
    if (!retroactiveDate) this.setState({ retroactiveDateInputError: 'Campo obrigatório.' })
    if (!retroactiveCheckInTime) this.setState({ retroactiveCheckInTimeInputError: 'Campo obrigatório.' })
    if (!retroactiveCheckOutTime) this.setState({ retroactiveCheckOutTimeInputError: 'Campo obrigatório.' })
    if (!justificativa) this.setState({ justificativaInputError: 'Campo obrigatório.' })

    if (
      justificativa
      && retroactiveDate
      && HOUR_MINUTE_REGEX.test(retroactiveCheckInTime)
      && HOUR_MINUTE_REGEX.test(retroactiveCheckOutTime)
      && (this.strToMins(retroactiveCheckOutTime) - this.strToMins(retroactiveCheckInTime) > 0)
      && !(
        moment(retroactiveDate).format('L') === moment().format('L')
        && this.strToMins(retroactiveCheckInTime) > this.strToMins(moment().format('LT'))
      )
      && !(
        moment(retroactiveDate).format('L') === moment().format('L')
        && this.strToMins(retroactiveCheckOutTime) > this.strToMins(moment().format('LT'))
      )
    ) {
      checkRetroactive({
        Data: moment(retroactiveDate).format('YYYY-MM-DD'),
        HoraEntrada: retroactiveCheckInTime,
        HoraSaida: retroactiveCheckOutTime,
      })
    }
  }

  render() {
    const {
      checkRetroactiveIsLoading, checkRetroactiveError, checkRetroactiveResult,
    } = this.props.humanResources
    const {
      retroactiveCheckOutTime, retroactiveCheckOutTimeInputError, retroactiveDateInputError,
      retroactiveCheckInTime, retroactiveCheckInTimeInputError,
      justificativa, justificativaInputError, retroactiveDate,
    } = this.state

    return (
      <div className="page-content">
        <Container fluid style={{ minHeight: 500 }}>
          <Breadcrumbs
            title="Registro de ponto retroativo"
            breadcrumbItems={[{
              title: '',
            }]}
          />

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              {checkRetroactiveResult
                && checkRetroactiveResult.ok === false
                && (
                <span
                  style={{
                    fontWeight: 'bold',
                    color: '#B30000',
                  }}
                >
                  {checkRetroactiveResult.msg
                    || (checkRetroactiveResult.codigo === 'sobreposicao'
                      ? 'Período já registrado.'
                      : 'Não foi possível registrar o ponto neste período.')}
                </span>
              )}
              {checkRetroactiveError && (
                <span
                  style={{
                    fontWeight: 'bold',
                    color: '#B30000',
                  }}
                >
                  {checkRetroactiveError}
                </span>
              )}
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Data</Label>
                <DatePicker
                  locale="pt-BR"
                  className="form-control"
                  selected={retroactiveDate}
                  /* maxDate={new Date(this.getPreviousWorkday())}
                  minDate={
                    new Date(this.getPreviousWorkday())
                      .setDate(new Date(this.getPreviousWorkday())
                        .getDate() - this.getSubtractFactor())
                  } */
                  dateFormat="dd/MM/yyyy"
                  /* filterDate={date => {
                    const day = moment(date).day()
                    return day !== 0 && day !== 6
                  }} */
                  onChange={retroactiveDate => this.setState({
                    retroactiveDate,
                    retroactiveDateInputError: '',
                  })}
                />
                {
                  retroactiveDateInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {retroactiveDateInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Hora de entrada</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={retroactiveCheckInTime}
                  maxLength={5}
                  onChange={e => this.setState({
                    retroactiveCheckInTime: e.target.value,
                    retroactiveCheckInTimeInputError: '',
                  })}
                />
                {
                  retroactiveCheckInTimeInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {retroactiveCheckInTimeInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Hora de saída</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={retroactiveCheckOutTime}
                  maxLength={5}
                  onChange={e => this.setState({
                    retroactiveCheckOutTime: e.target.value,
                    retroactiveCheckOutTimeInputError: '',
                  })}
                />
                {
                  retroactiveCheckOutTimeInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {retroactiveCheckOutTimeInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={3} lg={4} md={4} sm={4}>
              <FormGroup>
                <Label>Justificativa</Label>
                <Input
                  className="form-control"
                  type="text"
                  value={justificativa}
                  onChange={e => this.setState({
                    justificativa: e.target.value,
                    justificativaInputError: '',
                  })}
                />
                {
                  justificativaInputError
                  && (
                    <span style={{ color: 'red' }}>
                      {justificativaInputError}
                    </span>
                  )
                }
              </FormGroup>
            </Col>
          </Row>

          <Button
            type="button"
            color="primary"
            className="mt-3 waves-effect waves-light"
            disabled={checkRetroactiveIsLoading}
            onClick={() => this.handleCheckRetroactiveSubmit()}
          >
            Continuar
            {checkRetroactiveIsLoading && (
              <Spinner size="sm" className="ml-2" />
            )}
          </Button>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({ checkRetroactive }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(RetroactiveExpedient)

const HOUR_MINUTE_REGEX = new RegExp('^([01]?[0-9]|2[0-3]):[0-5][0-9]$')
